<template>
  <div 
    v-if="show && activity && activity.id" 
    class="modal-tooltip"
    :class="{ 
      'modal-background': isFinishModalOpen, 
      'tooltip-background': isFinishModalOpen,
      'right': isRight,
      'onBottom': isBottom
    }"
    :style="{ 
      top: position.y + 'px', 
      left: position.x + 'px'
    }"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <div class="modal-header">
      <div class="header-left">
        <component 
          v-if="activityIcon.type === 'component'" 
          :is="activityIcon.value" 
          class="header-icon" 
        />
        <i 
          v-else 
          :class="['fa', activityIcon.value, 'fa-icon']" 
        />
        <span class="header-title">{{ activity?.type?.name }}</span>
      </div>
      <button 
        :class="finalizarButton.class" 
        :disabled="finalizarButton.disabled"
        @click="openFinishActivityModal"
      >
        <component :is="finalizarButton.icon" v-if="finalizarButton.icon" class="finalizar-icon"/>
        <span class="finalizar-text">{{ finalizarButton.text }}</span>
      </button>
    </div>
    <div class="tooltip-lead">
      <div class="lead-left">
        <div class="lead-icon">
          <Avatar
          :name="activity?.lead?.name || '---'"
          :url="activity?.lead?.gravatar"
          class="lead-avatar"
          width="48"
        />
        </div>
        <div class="lead-info">
          <button 
            v-if="activity?.lead?.name" 
            class="lead-name button-link" 
            @click="openLeadPage(activity?.lead_hashid)"
          >
            {{ activity?.lead?.name }}
          </button>

          <button 
            v-if="activity?.deal?.title" 
            class="deal-title button-link" 
            @click="openDealPage(activity?.deal_hashid)"
          >
            {{ activity?.deal?.title }}
          </button>
          <small v-else class="deal-title">---</small>
        </div>
      </div>
      <div class="lead-right">
        <div class="followers d-flex">
          <Users class="tooltip-icon" />
          <div class="user-group">
            <Avatar
              v-for="(follower, index) in followers"
              :key="index"
              :name="follower.name"
              class="user-avatar"
              width="16"
            />
          </div>
        </div>
        <div class="lead-date">
          <Calendar class="tooltip-icon" />
          <span>{{ formatDate(activity?.scheduled_at) }}</span>
        </div>
        <div class="lead-time">
          <Clock class="tooltip-icon" />
          <span>{{ formatTime(activity?.scheduled_at) }} até {{ formatTime(activity?.schedule_ends_at) }}</span>
        </div>
      </div>
    </div>
    <div class="tooltip-details">
      <div class="tooltip-row">
        <Phone class="tooltip-icon" id="phone-tooltip" />
        <BTooltip 
          title="Telefone" 
          placement="left"
          boundary="window"
          :distance="18"
          target="phone-tooltip"
          customClass="custom-sellia-tooltip-schedule"
          @show="handleTooltipShow"
          @hidden="handleTooltipHidden"
        />
        <small class="lead-phone">{{ formatPhone(activity?.lead?.phone) }}</small>
      </div>
      <div class="tooltip-row">
        <Mail class="tooltip-icon" id="email-tooltip" />
        <BTooltip 
          title="E-mail" 
          placement="left"
          boundary="window"
          :distance="18"
          target="email-tooltip"
          customClass="custom-sellia-tooltip-schedule"
          @show="handleTooltipShow"
          @hidden="handleTooltipHidden"
        />
        <span>{{ activity?.lead?.email || '---' }}</span>
      </div>
      <div class="tooltip-row">
        <Location class="tooltip-icon" id="address-tooltip" />
        <BTooltip 
          title="Endereço" 
          placement="left"
          boundary="window"
          :distance="18"
          target="address-tooltip"
          customClass="custom-sellia-tooltip-schedule"
          @show="handleTooltipShow"
          @hidden="handleTooltipHidden"
        />
        <span>{{ formatFullAddress(activity?.lead) }}</span>
      </div>
    </div>
    <div class="activity-description">
      <span
        v-if="!activity?.summary"
        :class="contentClass"
      >
        {{ sanitizeContent(activity?.content) }}
      </span>
      <section
        v-else-if="!activity?.content"
        class="sellia-wrapper"
      >
        <div class="sellia-container">
          <BTooltip 
              :title="__('Criado com') + ' SelliA'" 
              placement="bottom" 
              boundary="viewport"
              :distance="18"
              target="star-tooltip"
              customClass="custom-sellia-tooltip-schedule"
              @show="handleTooltipShow"
              @hidden="handleTooltipHidden"
          ></BTooltip>
          <Stars class="sellia-star" id="star-tooltip"/>
          <span class="sellia-content sellia-limited">{{ sanitizeContent(activity?.summary) }}</span>
        </div>
        <div v-if="summaryUpdatedByName" class="summary-updated-text">
            Editado por: {{ summaryUpdatedByName }}
        </div>
      </section>
      <section v-else class="content-sellia">
        <span :class="contentClass">{{ sanitizeContent(activity?.content) }}</span>
        <p class="sellia-container mb-1">
        <BTooltip 
            :title="__('Criado com') + ' SelliA'" 
            placement="bottom" 
            boundary="viewport"
            :distance="18"
            target="star-tooltip"
            customClass="custom-sellia-tooltip-schedule"
            @show="handleTooltipShow"
            @hidden="handleTooltipHidden"
        ></BTooltip>
          <Stars class="sellia-star" id="star-tooltip"/>
          <span class="sellia-content sellia-limited">{{ sanitizeContent(activity?.summary) }}</span>
          <div v-if="summaryUpdatedByName" class="summary-updated-text">
              Editado por: {{ summaryUpdatedByName }}
          </div>
        </p>
      </section>
    </div>
    <FinishActivityModal 
      ref="finishActivityModal"
      :activityId="activity?.id"
      @confirmFinish="handleFinishActivity"
      @close="handleCloseFinishModal"
    />
  </div>
</template>


<script>
import Phone from '../components/icon/Phone.vue';
import Meeting from '../components/icon/Meeting.vue';
import Calendar from '../components/icon/Calendar.vue';
import Clock from '../components/icon/Clock.vue';
import Mail from '../components/icon/Mail.vue';
import Location from '../components/icon/Location.vue';
import Users from '../components/icon/Users.vue';
import Stars from '../components/icon/Stars.vue';
import Avatar from '../components/Avatar.vue';
import SadIcon from '../components/icon/SadIcon.vue';
import HappyIcon from '../components/icon/HappyIcon.vue';
import FinishActivityModal from '../components/activity/FinishActivityModal.vue';
import FileText from '../components/icon/File.vue';
import Tooltip from '../components/Tooltip.vue';
import { BTooltip } from 'bootstrap-vue';

export default {
  data() {
    return {
      isHovering: false,
      isFinishModalOpen: false,
      isVisible: false,
      isTooltipHovering: false,
      activeTooltips: 0
    };
  },
  components: {
    Phone,
    Meeting,
    Calendar,
    Clock,
    Mail,
    Location,
    Users,
    Stars,
    Avatar,
    FinishActivityModal,
    Tooltip,
    BTooltip,
  },
  props: {
    show: Boolean,
    activity: Object,
    position: Object
  },
  computed: {
    activityIcon() {
      const icons = {
        "Reunião": { type: "component", value: Meeting },
        "Ligação": { type: "component", value: Phone },
        "Visita": { type: "fa", value: "fa-briefcase" },
        "Follow Up": { type: "fa", value: "fa-envelope-o" },
        "Proposta": { type: "component", value: FileText },
      };

      return icons[this.activity?.type?.name];
    },
    summaryUpdatedByName() {
      return this.activity?.summary_updated_by?.name;
    },
    contentClass() {
      return this.activity?.summary ? "content-limited-4" : "content-limited-8";
    },
    finalizarButton() {
      if (!this.activity?.completed_status && this.activity?.completed_at) {
        return {
          text: "Finalizado",
          icon: null,
          class: "finalizar-btn finished",
          disabled: true,
        };
      }

      if (!this.activity?.completed_status) {
        return {
          text: "Finalizar",
          icon: null,
          class: "finalizar-btn default",
          disabled: false,
        };
      }

      if (this.activity.completed_status === "successfully") {
        return {
          text: "Finalizado com sucesso",
          icon: HappyIcon,
          class: "finalizar-btn success",
          disabled: true,
        };
      }

      if (this.activity.completed_status === "unsuccessfully") {
        return {
          text: "Finalizado sem sucesso",
          icon: SadIcon,
          class: "finalizar-btn failure",
          disabled: true,
        };
      }

      return {
        text: "Finalizar",
        icon: null,
        class: "finalizar-btn default",
        disabled: false,
      };
    },
    assignedUsers() {
      return this.activity?.assigned_users || [];
    },
    followers() {
      return Array.isArray(this.activity?.followers) && this.activity.followers.length > 0
        ? this.activity.followers.map(follower => ({
            name: follower.name || "Sem nome",
          }))
        : [];
    },
    isRight() {
      if (!this.position) return false;
      return (window.innerWidth - this.position.x) < 455;
    },
    isBottom() {
      if (!this.position) return false;
      const TOOLTIP_HEIGHT = 400; // Altura aproximada do tooltip
      // Verifica se tem espaço suficiente acima
      return this.position.y < TOOLTIP_HEIGHT;
    }
  },

  mounted() {
    this.updatePosition();
  },


  watch: {
    position: {
      handler() {
        this.updatePosition();
      },
      immediate: true,
      deep: true,
      show(newValue) {
        if (newValue) {
          this.isVisible = true;
        }
      }
    }
  },

  methods: {
    onMouseEnter() {
      this.$emit('mouseenters');
    },

    onMouseLeave() {
      this.$emit('mouseleaves');
    },

    updatePosition() {
      if (this.$el && this.position) {
        this.$nextTick(() => {
          const modalHeight = this.$el.offsetHeight;
          const viewportBottom = window.scrollY + window.innerHeight;

          let top = this.position.y;

          if (top + modalHeight > viewportBottom - 16) {
            top = viewportBottom - modalHeight - 16;
          }

          if (top < window.scrollY + 16) {
            top = window.scrollY + 16;
          }

          this.$el.style.top = `${top}px`;
          this.$el.style.left = `${this.position.x}px`;
        });
      }
    },

    handleMouseEnter() {
      this.isHovering = true;
      this.$emit('mouseenters');
    },

    handleMouseLeave() {
      if (!this.isFinishModalOpen && !this.isTooltipHovering) {
        this.isHovering = false;
        this.$emit('mouseleaves');
      }
    },

    openLeadPage(leadHashid) {
      if (leadHashid) {
        window.open(`/lead/${leadHashid}`);
      }
    },

    openDealPage(dealHashid) {
      if (dealHashid) {
        window.open(`/deal#/${dealHashid}`);
      }
    },

    openFinishActivityModal() {
      if (this.$refs.finishActivityModal) {
        this.isFinishModalOpen = true;
        this.$refs.finishActivityModal.handleOpen(this.activity);
      }
    },

    handleCloseFinishModal() {
      this.isFinishModalOpen = false;
      this.isHovering = false;
      
      this.$emit('mouseleaves');
      this.$emit('close');
      this.$emit('update:show', false);
    },

    handleFinishActivity({ activity, completed_status, closeModal }) {
      this.$http.put(`/lead/${activity.lead_hashid}/activity/${activity.id}`, { complete: true, completed_status })
        .then(response => {
          this.$set(activity, 'completed_status', completed_status);
          
          if (closeModal) {
            closeModal();
          }
          
          this.isFinishModalOpen = false;
          this.isHovering = false;
          
          this.$emit('mouseleaves');
          this.$emit('close');
          this.$emit('update:show', false);
          this.$emit('activityCompleted');

          Bus.$emit('activityCompleted', activity);
        })
        .catch(error => {
          Alert.error("Erro ao salvar atividade.");
        });
    },

    initials(name = '') {
      return name
        ? name.split(" ").map(word => word[0]).join("").toUpperCase()
        : "N/A";
    },
    formatDate(date) {
      return date ? new Date(date).toLocaleDateString("pt-BR") : "--/--/----";
    },
    formatTime(date) {
      return date ? new Date(date).toLocaleTimeString("pt-BR", { hour: '2-digit', minute: '2-digit' }) : "--:--";
    },
    formatPhone(phone) {
      if (!phone) return "---";
      phone = phone.replace(/\D/g, "");
      const regex = /^(\d{0,2})?(\d{2})(\d{4,5})(\d{4})$/;
      const match = phone.match(regex);

      if (!match) return phone;

      const ddi = match[1] ? `+${match[1]} ` : "";
      const ddd = match[2];
      const firstPart = match[3];
      const secondPart = match[4];

      return `${ddi}(${ddd}) ${firstPart}-${secondPart}`;
    },
    formatFullAddress(lead) {
      if (!lead) return "---";

      const city = lead.city;
      const state = lead.state;
      const country = lead.country;

      const parts = [];
      if (city) parts.push(city);
      if (state) parts.push(state);
      if (country) parts.push(country);

      return parts.length > 0 ? parts.join(', ') : "---";
    },
    sanitizeContent(content) {
      if (!content) return "";
      return content
        .replace(/<\/?[^>]+(>|$)/g, "")
        .trim();
    },
    handleTooltipShow() {
      this.activeTooltips++;
      this.isTooltipHovering = true;
    },

    handleTooltipHidden() {
      this.activeTooltips--;
      if (this.activeTooltips === 0) {
        this.isTooltipHovering = false;
      }
    },
  },

  beforeDestroy() {
    this.isHovering = false;
    this.isFinishModalOpen = false;
    this.isVisible = false;
  },
};
</script>

<style scoped>
.modal-tooltip {
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 455px;
  max-height: calc(100vh - 32px);
  overflow: auto;
  background: #FFFFFF;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  z-index: 9999;
  font-family: 'Montserrat', sans-serif;
}

/* Quando o modal de finalização está aberto */
.modal-tooltip.modal-background {
  z-index: 1000;
  pointer-events: none !important;
}

/* Garantimos que o modal de finalização fique na frente */
:deep(#activity-finish-modal) {
  z-index: 10000 !important;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 47px;
  border-bottom: 1px solid #D1D1D1;
  padding: 0 24px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.finalizar-btn {
  border-radius: 8px;
  padding: 4px 16px;
  font-size: 12px;
  font-weight: 400;
  color: #242424;
  border: none;
  cursor: pointer;
}

.finalizar-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  gap: 8px;
  width: 181px;
  height: 26px;
  border-radius: 8px;
  border: none;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  cursor: pointer;
}

.finalizar-btn.default {
  background: #ECE7FF;
  color: #242424;
}

.finalizar-btn.success {
  background: rgba(209, 255, 202, 0.6);
  color: #0F9030;
  cursor: not-allowed;
}

.finalizar-btn.failure {
  background: #FBD9D7;
  color: #FF3B30;
  cursor: not-allowed;
}

.finalizar-btn.finished {
  background: transparent;
  color: #3B334A;
  cursor: not-allowed;
  padding: 0px 0px;
  justify-content: flex-end;
}

.finalizar-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.finalizar-text {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: inherit;
}

.finalizar-btn:disabled {
  opacity: 0.7;
  cursor: default; 
}

.tooltip-lead {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 16px 24px;
}

.tooltip-details {
  display: flex;
  flex-direction: column;
  padding: 0 24px 0 24px;
  gap: 6px;
}

.tooltip-details .tooltip-row:last-of-type {
  margin-bottom: 16px;
}

.tooltip-row {
  display: flex;
  align-items: center;
  overflow: visible;
  position: relative;
  padding-left: 8px;
}

.lead-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.lead-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
}

.user-avatar {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  object-fit: cover;
  font-size: 8px;
  margin-left: -4px;
  cursor: default;
}

.lead-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 180px;
}

.lead-name {
  font-size: 16px;
  font-weight: bold;
  color: #242424;
  line-height: 150%;
}

.lead-company {
  font-size: 12px;
  color: #242424;
  line-height: 150%;
}

.lead-right {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

image.png
.followers, .lead-time {
  display: flex;
  align-items: center;
  color: #242424;
}

.lead-date {
  display: flex;
  align-items: center;
  color: #242424;
  font-weight: 600;
}

.tooltip-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  transition: color 0.2s ease;
  position: relative;
  z-index: 1;
}

.tooltip-icon:hover {
  color: #5F33FF;
}

.user-group {
  display: flex;
  align-items: center;
}

.activity-description {
  font-size: 12px;
  color: #242424;
  font-family: 'Inter', sans-serif;
  margin: 0 24px 24px 24px;
}

.content-sellia {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sellia-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.sellia-content.sellia-black {
  font-size: 12px;
  font-weight: 400;
  color: #242424;
  font-family: 'Inter', sans-serif;
}

.sellia-container {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  max-width: 100%;
  overflow: hidden;
}

.sellia-text {
  font-size: 12px;
  font-weight: 600;
  color: #5F33FF;
  font-family: 'Inter', sans-serif;
  line-height: 1.5;
}

.sellia-star {
  display: inline-block;
  vertical-align: middle;
  width: 14px !important;
  height: 14px !important;
  fill: #8869FD;
  position: relative;
  top: 2px !important;
  flex-shrink: 0; 
}

.sellia-content {
  display: -webkit-box; 
  -webkit-box-orient: vertical; 
  -webkit-line-clamp: 4; 
  line-clamp: 4; 
  overflow: hidden; 
  text-overflow: ellipsis; 
  max-width: 393px; 
  font-size: 12px;
  font-weight: 500;
  color: #5F33FF;
  font-family: 'Inter', sans-serif;
  line-height: 1.5; 
}


.sellia-marker {
  display: flex;
  align-items: flex-start;
  gap: 5px;
}

.lead-avatar, .user-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}

.modal-background {
  pointer-events: none;
}

.content-limited-8 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 8;
  line-clamp: 8;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  white-space: normal;
}

.content-limited-4 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  white-space: normal;
}

.sellia-limited {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  white-space: normal;
}
.button-link {
  background: none;
  border: none;
  padding: 0;
  font-size: inherit;
  color: #242424;
  text-align: left;
  cursor: pointer;
}

.button-link:hover {
  text-decoration: none;
}

.lead-name {
  font-size: 16px;
}

.deal-title {
  font-size: 12px;
}

.summary-updated-text {
  color: #71767D;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-top: 4px;
}

.fa-icon {
  font-size: 17px;
  width: 17px;
  height: 17px;
  display: inline-block;
}

.tooltip-row span,
.tooltip-row small {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
  cursor: default;
}

.tooltip-row span:hover,
.tooltip-row small:hover {
  color: #5F33FF;
}

::v-deep.custom-sellia-tooltip-schedule.tooltip.b-tooltip {
  filter: drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.12)) drop-shadow(0px 15px 35px rgba(103, 110, 118, 0.08));
  background: #000000 !important;
  opacity: 1 !important;
  border-radius: 8px !important;
  position: relative;
  margin-right: 8px;
}

::v-deep.custom-sellia-tooltip-schedule.tooltip.b-tooltip[x-placement^="bottom"] {
  margin-top: 8px !important;
}

::v-deep.custom-sellia-tooltip-schedule.tooltip.b-tooltip .arrow {
  display: none !important;
}

::v-deep.custom-sellia-tooltip-schedule.tooltip.b-tooltip .arrow::before {
  display: none !important;
}

::v-deep.custom-sellia-tooltip-schedule.tooltip.b-tooltip[x-placement^="left"]::after {
  content: "" !important;
  position: absolute !important;
  right: -5px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  border-top: 6px solid transparent !important;
  border-bottom: 6px solid transparent !important;
  border-left: 7px solid #000000 !important;
  border-right: none !important;
  width: 0 !important;
  height: 0 !important;
  z-index: 1 !important;
}

::v-deep.custom-sellia-tooltip-schedule.tooltip.b-tooltip[x-placement^="bottom"]::after {
  content: "" !important;
  position: absolute !important;
  top: -5px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  border-left: 5px solid transparent !important;
  border-right: 5px solid transparent !important;
  border-bottom: 5px solid #000000 !important;
  border-top: none !important;
  width: 0 !important;
  height: 0 !important;
  z-index: 2 !important;
}

.sellia-inline-container {
  display: flex;
  align-items: center;
  gap: 4px;
}

.tooltip-row .tooltip-icon {
  margin-right: 12px;
}

::v-deep.custom-sellia-tooltip-schedule.tooltip.b-tooltip .tooltip-inner {
    display: flex;
    padding: 8px 7px;
    align-items: center;
    gap: 4px;
    border-radius: 8px;
    background: var(--Primary-Black, #000);
    color: #FFF;
    min-height: 28px;
    min-width: 62px;
    max-width: 200px;
    text-align: center;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: 500;
}

</style>